import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as n, normalizeClass as o, createElementVNode as d } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconTransportation",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], m = /* @__PURE__ */ d("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 2a.5.5 0 0 0-.5.5V5h3V2H3Zm0-1a1.5 1.5 0 0 0-1.5 1.5v6A1.5 1.5 0 0 0 3 10h.066l-.482.723a.5.5 0 0 0 .832.555L4.268 10h3.465l.851 1.277a.5.5 0 1 0 .832-.555L8.934 10H9a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 9 1H3Zm3.5 1v3h3V2.5A.5.5 0 0 0 9 2H6.5Zm3 4h-7v2.5A.5.5 0 0 0 3 9h6a.5.5 0 0 0 .5-.5V6Zm-6 1.5A.5.5 0 0 1 4 7h.005a.5.5 0 1 1 0 1H4a.5.5 0 0 1-.5-.5Zm4 0A.5.5 0 0 1 8 7h.005a.5.5 0 1 1 0 1H8a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), _ = [
  m
];
function h(e, u, r, p, f, a) {
  return n(), i("svg", {
    "aria-label": r.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--transportation"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Transportation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, _, 10, c);
}
const b = /* @__PURE__ */ l(s, [["render", h]]);
export {
  b as default
};
//# sourceMappingURL=transportation.js.map
